module.exports = __webpack_public_path__ + "static-v-shop/1777291938265/img/logo_naranja.00996b70.png";